import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="bookmark-visibility"
export default class extends Controller {
    toggle(e) {
        const checkbox = e.target
        this.send(checkbox.dataset.id, checkbox.checked, checkbox)
    }

    // send posts the desired visibility. The first time a user goes public without a public username
    // yet, the server answers { needs_username: true } instead of tagging; we open the shared modal
    // (public-username controller) and, once a username is claimed, retry the same toggle.
    send(id, isPublic, checkbox) {
        const csrfToken = document.querySelector("[name='csrf-token']").content

        fetch(`/bookmarks/${id}/visibility`, {
            method: "POST",
            cache: "no-cache",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": csrfToken
            },
            body: JSON.stringify({ visibility: isPublic })
        }).then(response => {
            if (!response.ok) throw new Error(`Visibility update failed: ${response.status}`)
            return response.json()
        }).then(data => {
            if (data.needs_username) {
                checkbox.checked = false
                document.dispatchEvent(new CustomEvent("public-username:required", {
                    detail: {
                        suggested: data.suggested_username || "",
                        onClaimed: () => { checkbox.checked = true; this.send(id, true, checkbox) }
                    }
                }))
                return
            }
            window.toast(isPublic ? "Bookmark is now public on your Birdfeeder profile" : "Bookmark is now private", { kind: "notice" })
        }).catch(() => {
            checkbox.checked = !isPublic
            window.toast("Couldn't update visibility. Please try again.", { kind: "alert" })
        })
    }
}
